import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AuthService } from './../../services/API/auth/auth.service';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { NotificationServiceService } from './../../services/notification-service/notification-service.service';
import { ScalesService } from './../../services/API/scales/scales.service';
import { AppVersionService } from './../../services/app-version/app-version.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {

  loginForm: UntypedFormGroup;
  loginEmail: string = "";
  loginPassword: string = "";
  saveCredentials: boolean = true;

  loading: boolean = false;

  registerForm: UntypedFormGroup;
  registerName: string = "";
  registerSurname: string = "";
  registerEmail: string = "";
  registerPassword: string = "";
  registerPasswordVerify: string = "";

  constructor(
    private fb: UntypedFormBuilder,
    public router: Router,
    private authService: AuthService,
    private notificationService: NotificationServiceService,
    private scalesService: ScalesService,
    private appVersionService: AppVersionService,
  ) {
  }

  ngOnInit() {

    localStorage.setItem('appAuthToken', '');
    localStorage.setItem('appAuthRol', '');
    localStorage.setItem('appUserName', '');
    localStorage.setItem('appUserSurname', '');
    localStorage.setItem('appUserEmail', '');
    localStorage.setItem('appUserID', '');
    localStorage.setItem('appUserActive', '');

    this.loginForm = this.fb.group({
      loginEmail: [this.loginEmail, [Validators.required, Validators.minLength(1), Validators.maxLength(255), Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\.+[a-z]{2,4}$")]],
      loginPassword: [this.loginPassword, [Validators.required, Validators.minLength(8), Validators.maxLength(255)]],
    });
    this.registerForm = this.fb.group({
      registerName: [this.registerName, [Validators.required, Validators.minLength(1), Validators.maxLength(128)]],
      registerSurname: [this.registerSurname, [Validators.required, Validators.minLength(1), Validators.maxLength(128)]],
      registerEmail: [this.registerEmail, [Validators.required, Validators.minLength(1), Validators.maxLength(255), Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\.+[a-z]{2,4}$")]],
      registerPassword: [this.registerPassword, [Validators.required, Validators.minLength(8), Validators.maxLength(255)]],
      registerPasswordVerify: [this.registerPasswordVerify, [Validators.required, Validators.minLength(8), Validators.maxLength(255)]],
    });

    this.loginForm.controls['loginEmail'].setValue((localStorage.getItem('appEmail') || ""));
    this.loginForm.controls['loginPassword'].setValue((localStorage.getItem('appPassword') || ""));
    this.saveCredentials = (Boolean(localStorage.getItem('appSaveCredentiasl') || false));

  }

  iniciarSesion() {
    const {valid} = this.loginForm;
    if(valid){
      this.loading = true;

      setTimeout(()=>{
        this.loading = false;
      }, 5000);

      var email = this.loginForm.controls['loginEmail'].value;
      var password = this.loginForm.controls['loginPassword'].value;
      if(this.saveCredentials == true){
        localStorage.setItem('appEmail', email);
        localStorage.setItem('appPassword', password);
        localStorage.setItem('appSaveCredentiasl', this.saveCredentials.toString());
      }else{
        localStorage.setItem('appEmail', '');
        localStorage.setItem('appPassword', '');
        localStorage.setItem('appSaveCredentiasl', '');
      }

      this.authService.login(email, password).subscribe(data => {

        localStorage.setItem('appAuthToken', data["token"]);
        localStorage.setItem('appAuthRol', data["user_rol"]);
        localStorage.setItem('appUserName', data["user_name"]);
        localStorage.setItem('appUserSurname', data["user_surname"]);
        localStorage.setItem('appUserEmail', data["user_email"]);
        localStorage.setItem('appUserID', data["user_id"]);
        localStorage.setItem('appUserActive', data["user_active"]);
        localStorage.setItem('permission', JSON.stringify(data["permission"]));

        const expiresAt = this.setTTLExpiration((parseInt(data["expires_at"]) - 1));
        localStorage.setItem("expires_at", expiresAt.toString());

        // Cache allowed scales count for menu logic.
        this.scalesService.getAllowedScales('true').pipe(
          catchError(() => of([]))
        ).subscribe((scales: any) => {
          try {
            const count = Array.isArray(scales) ? scales.length : 0;
            localStorage.setItem('allowed_scales_count', String(count));
          } catch {
            localStorage.setItem('allowed_scales_count', '0');
          }
          this.loading = false;
          this.notificationService.openSnackBar("¡Bienvenido!");
          this.router.navigateByUrl('/dashboard/home').then(() => {
            this.appVersionService.showPendingUpdateFailedDialogIfNeeded();
          });
        });

      }, error => {
        if(error.status){
          this.notificationService.openSnackBar("¡Contraseña incorrecta!");
        }else{
          this.notificationService.openSnackBar("¡Se ha producido un error!");
        }
        this.loading = false;
      });
    }
  }

  registrar() {
    const {valid} = this.registerForm;
    if(valid){
      this.loading = true;

      setTimeout(()=>{
        this.loading = false;
      }, 5000);

    }
  }

  setTTLExpiration(hours: number = 24){
    var now = new Date();
    now.setHours(now.getHours() + hours);
    return now;
  }

}
